import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as i } from "react";
const t = ({
  title: o,
  titleId: l,
  ...r
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": l,
    ...r,
    children: [
      o ? /* @__PURE__ */ e.jsx("title", { id: l, children: o }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M310.069 826.938V632.399h28.181c32.789 112.341 91.371 168.512 175.744 168.512 36.629 0 64.021-11.093 82.069-33.28 18.091-22.165 27.136-46.507 27.136-73.024 0-30.848-9.643-56.149-28.949-75.947-19.733-19.755-58.069-43.627-114.965-71.595-59.776-29.397-102.699-58.325-128.747-86.784-26.005-27.947-39.04-62.421-39.04-103.403 0-39.04 13.995-76.288 41.941-111.723 27.968-35.435 67.264-53.163 117.888-53.163 51.584 0 94.251 20.971 128 62.933 7.211-7.232 16.64-24.853 28.203-52.8h26.752V385.08H627.53c-9.643-43.861-28.331-81.6-56.064-113.173-27.712-31.573-60.373-47.36-97.984-47.36-28.907 0-52.288 8.917-70.144 26.752-17.835 17.835-26.752 38.571-26.752 62.187 0 26.027 9.877 48.469 29.653 67.264 19.285 19.285 56.171 41.216 110.635 65.792 81.963 37.141 132.117 73.301 150.421 108.48 18.325 35.691 27.477 69.909 27.477 102.699 0 51.584-16.981 93.547-50.965 125.824-33.984 32.299-76.779 48.448-128.363 48.448-54.485 0-102.933-22.4-145.365-67.243-13.013 14.464-23.616 35.179-31.829 62.187zm-96.736-293.605h578.176v-42.667H213.333z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = i(t);
export {
  n as default
};
